/**
 * Welcher Creep in welche Reihe gehoert (Produktentscheidung vom 27.09.2026).
 *
 * Bis v0.29 hat der Spieler selbst entschieden, ob ein Creep nach FRONT,
 * CENTER oder BACK kommt. In einem Spiel, das in Minuten entschieden wird, war
 * das drei Entscheidungen zu viel: Man will eine Welle zusammenstellen, nicht
 * eine Aufstellung sortieren.
 *
 * Jetzt steht die Reihe fest und ergibt sich aus dem, was ohnehin auf der Karte
 * steht - den Tags des Creeps. Der Spieler waehlt nur noch, WAS mitkommt.
 *
 * Warum die Reihe trotzdem wichtig ist: Sie bestimmt die Ankunftsreihenfolge.
 * FRONT erscheint zuerst beim Gegner, dann CENTER, dann BACK, mit einer Pause
 * dazwischen (siehe wave-formation.ts). Panzer fangen also ab, waehrend die
 * Fernkaempfer noch unterwegs sind.
 *
 * Die Regel:
 *
 *   BACK    Fernkampf oder Economy - alles, was geschuetzt werden will
 *   CENTER  schnelle Einheiten - sie ueberholen die Formation ohnehin
 *   FRONT   alles Uebrige: Nahkampf, Panzer, Belagerung, Bosse
 *
 * Wirtschaftscreeps stehen bewusst hinten: Sie kaempfen nicht und bringen nur
 * dann Income, wenn sie eine Weile leben.
 */

import { requireCreep } from './economy.js';
import type { WavePlan, WaveRow } from './army.js';

/** Die Reihe dieses Creeps - immer dieselbe, unabhaengig vom Spieler. */
export function getCreepRow(creepId: string): WaveRow {
  const tags = requireCreep(creepId).tags as readonly string[];

  // Reihenfolge der Pruefung ist die Rangfolge der Regel.
  if (tags.includes('ranged') || tags.includes('economy')) return 'back';
  if (tags.includes('fast')) return 'center';
  return 'front';
}

/**
 * Baut aus einer blossen Liste von Creeps die fertige Aufstellung.
 *
 * Die Reihenfolge innerhalb einer Reihe bleibt die Reihenfolge der Eingabe -
 * wer zuerst hinzugefuegt wurde, laeuft auch zuerst los.
 */
export function buildWavePlan(creepIds: readonly string[]): WavePlan {
  const front: string[] = [];
  const center: string[] = [];
  const back: string[] = [];

  for (const creepId of creepIds) {
    const row = getCreepRow(creepId);
    if (row === 'front') front.push(creepId);
    else if (row === 'center') center.push(creepId);
    else back.push(creepId);
  }

  return { front, center, back };
}
